import React, { useEffect, useRef, useState } from "react";
import {
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Spin,
  TimePicker,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import { paybillStatusData, spaPaybillTypeData } from "../../../../data";

const { TextArea } = Input;
const AddSpaPaybillModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { saving } = useSelector((state) => state.save);

  const onFinish = async (data) => {
    data.apbId = prodd.apbId ?? null;
    const res = await dispatch(
      save({
        ...data,
        url: "api/v1/active-paybill/save-spa-paybill",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  useEffect(() => {
    if (prodd) {
      form.setFieldsValue(prodd);
    } else {
      form.resetFields();
    }
  }, [prodd, form]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={prodd ? `Edit ${prodd?.apbNumber}` : "Add paybill details"}
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            name="apbNumber"
            label="Paybill"
            rules={[
              {
                required: true,
                message: "Enter Paybill",
              },
            ]}
          >
            <InputNumber
              min={0}
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              className="input flex"
              disabled={!!prodd?.apbId}
            />
          </Form.Item>
          <Form.Item
            name="apbType"
            className=""
            label={<span>Type</span>}
            rules={[
              {
                required: true,
                message: "Please select type",
              },
            ]}
          >
            <Select
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                spaPaybillTypeData?.length > 0 &&
                spaPaybillTypeData?.map((item) => ({
                  value: item?.value,
                  label: item?.label,
                }))
              }
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {}}
              disabled={!!prodd?.apbId}
            />
          </Form.Item>

          <Form.Item
            name="apbUser"
            label="User"
            rules={[
              {
                required: true,
                message: "Enter Paybill user",
              },
            ]}
          >
            <Input className="input" disabled={!!prodd?.apbId} />
          </Form.Item>

          <Form.Item
            name="apbPassword"
            label="Password"
            rules={[
              {
                required: false,
                message: "Please add password",
              },
            ]}
          >
            <Input.Password className="input" disabled={!!prodd?.apbId} />
          </Form.Item>
          <Form.Item
            name="apbDesc"
            label="Description"
            rules={[
              {
                required: true,
                message: "Enter Description",
              },
            ]}
          >
            <TextArea
              rows={4}
              className="input-textarea"
              disabled={!!prodd?.apbId}
            />
          </Form.Item>
          {prodd?.apbId && (
            <Form.Item
              name="apbStatus"
              className=""
              label={<span>Status</span>}
              rules={[
                {
                  required: true,
                  message: "Please select status",
                },
              ]}
            >
              <Select
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  paybillStatusData?.length > 0 &&
                  paybillStatusData?.map((item) => ({
                    value: item?.value,
                    label: item?.label,
                  }))
                }
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
                onDropdownVisibleChange={() => {}}
              />
            </Form.Item>
          )}

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn-2"
                  disabled={saving}
                >
                  {saving ? <Spin /> : prodd?.apbId ? "Update" : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddSpaPaybillModal;
